import { useTranslation } from 'react-i18next';

import type { ProductStatus } from '~/api/products/types';
import type { IconName } from '~/components/Icon/Icon';
import type { statusColorThemes } from '~/styles/themes.css';

import { StatusTag } from '~/components';

type StatusEntry = {
  icon: IconName;
  status: keyof typeof statusColorThemes;
};

const statusMap: Record<ProductStatus, StatusEntry> = {
  Approved: { icon: 'Check', status: 'success' },
  InReview: { icon: 'HourglassBottom', status: 'neutral' },
  Rejected: { icon: 'CloseSmall', status: 'danger' },
};

type Props = {
  status: ProductStatus;
};

export const ProductStatusTag = ({ status }: Props) => {
  const { icon, status: statusTheme } = statusMap[status];

  const { t } = useTranslation(['products']);

  return <StatusTag icon={icon} label={t(`products:overview.columns.status.options.${status}`)} status={statusTheme} />;
};
